import { render } from "./garage-sync.vue?vue&type=template&id=ad82a606"
import script from "./garage-sync.vue?vue&type=script&lang=js"
export * from "./garage-sync.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__